var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "dialogDrag", rawName: "v-dialogDrag" }],
      attrs: {
        title: _vm.title,
        center: "",
        "close-on-click-modal": false,
        visible: _vm.visible,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          ref: "inputForm",
          class: _vm.method === "view" ? "readonly" : "",
          attrs: {
            size: "small",
            model: _vm.inputForm,
            "label-width": "120px",
            "element-loading-text": "正在测试数据库连接",
            disabled: _vm.method === "view",
          },
          nativeOn: {
            keyup: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              return _vm.doSubmit()
            },
            submit: function ($event) {
              $event.preventDefault()
            },
          },
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 15 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "连接名称",
                        prop: "name",
                        rules: [
                          {
                            required: true,
                            message: "连接名称不能为空",
                            trigger: "blur",
                          },
                        ],
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: { maxlength: "50", placeholder: "" },
                        model: {
                          value: _vm.inputForm.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.inputForm, "name", $$v)
                          },
                          expression: "inputForm.name",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "连接英文名",
                        prop: "enName",
                        rules: [
                          {
                            required: true,
                            message: "连接英文名不能为空",
                            trigger: "blur",
                          },
                          { validator: _vm.checkEnName, trigger: "blur" },
                        ],
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: { maxlength: "50", placeholder: "" },
                        model: {
                          value: _vm.inputForm.enName,
                          callback: function ($$v) {
                            _vm.$set(_vm.inputForm, "enName", $$v)
                          },
                          expression: "inputForm.enName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "数据库类型",
                        prop: "type",
                        rules: [
                          {
                            required: true,
                            message: "数据库类型不能为空",
                            trigger: "blur",
                          },
                        ],
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { placeholder: "请选择来源" },
                          model: {
                            value: _vm.inputForm.type,
                            callback: function ($$v) {
                              _vm.$set(_vm.inputForm, "type", $$v)
                            },
                            expression: "inputForm.type",
                          },
                        },
                        _vm._l(
                          _vm.$dictUtils.getDictList("db_type"),
                          function (item) {
                            return _c("el-option", {
                              key: item.value,
                              attrs: { label: item.label, value: item.value },
                            })
                          }
                        ),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "主机地址",
                        prop: "host",
                        rules: [
                          {
                            required: true,
                            message: "主机地址不能为空",
                            trigger: "blur",
                          },
                        ],
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: { maxlength: "50", placeholder: "" },
                        model: {
                          value: _vm.inputForm.host,
                          callback: function ($$v) {
                            _vm.$set(_vm.inputForm, "host", $$v)
                          },
                          expression: "inputForm.host",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "端口",
                        prop: "port",
                        rules: [
                          {
                            required: true,
                            message: "端口不能为空",
                            trigger: "blur",
                          },
                        ],
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "number",
                          maxlength: "50",
                          placeholder: "",
                        },
                        model: {
                          value: _vm.inputForm.port,
                          callback: function ($$v) {
                            _vm.$set(_vm.inputForm, "port", _vm._n($$v))
                          },
                          expression: "inputForm.port",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "数据库名",
                        prop: "databaseName",
                        rules: [
                          {
                            required: true,
                            message: "数据库名不能为空",
                            trigger: "blur",
                          },
                        ],
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: { maxlength: "50", placeholder: "" },
                        model: {
                          value: _vm.inputForm.databaseName,
                          callback: function ($$v) {
                            _vm.$set(_vm.inputForm, "databaseName", $$v)
                          },
                          expression: "inputForm.databaseName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "数据库用户名",
                        prop: "username",
                        rules: [
                          {
                            required: true,
                            message: "数据库用户名不能为空",
                            trigger: "blur",
                          },
                        ],
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: { maxlength: "50", placeholder: "" },
                        model: {
                          value: _vm.inputForm.username,
                          callback: function ($$v) {
                            _vm.$set(_vm.inputForm, "username", $$v)
                          },
                          expression: "inputForm.username",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "数据库密码",
                        prop: "password",
                        rules: [
                          {
                            required: true,
                            message: "数据库密码名不能为空",
                            trigger: "blur",
                          },
                        ],
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: { maxlength: "50", placeholder: "" },
                        model: {
                          value: _vm.inputForm.password,
                          callback: function ($$v) {
                            _vm.$set(_vm.inputForm, "password", $$v)
                          },
                          expression: "inputForm.password",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "是否启用", prop: "enable" } },
                    [
                      _c("el-switch", {
                        model: {
                          value: _vm.inputForm.enable,
                          callback: function ($$v) {
                            _vm.$set(_vm.inputForm, "enable", $$v)
                          },
                          expression: "inputForm.enable",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _vm.method != "view"
            ? _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.testDbLink()
                    },
                  },
                },
                [_vm._v("测试连接")]
              )
            : _vm._e(),
          _vm.method != "view"
            ? _c(
                "el-button",
                {
                  directives: [
                    { name: "noMoreClick", rawName: "v-noMoreClick" },
                  ],
                  attrs: { size: "small", icon: "el-icon-circle-check" },
                  on: {
                    click: function ($event) {
                      return _vm.doSubmit()
                    },
                  },
                },
                [_vm._v("确定")]
              )
            : _vm._e(),
          _c(
            "el-button",
            {
              attrs: { size: "small", icon: "el-icon-circle-close" },
              on: {
                click: function ($event) {
                  _vm.visible = false
                },
              },
            },
            [_vm._v("关闭")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }